import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function createLeadNote(leadId, body) {

  try {
    return await axios.post(`${LEADS_ENDPOINT}/notes/${leadId}`, body)
  } catch {    
    throw new Error()
  }
}